export const PULSE_SUPPORT_EMAIL = 'pp@rgs.ru';
export const PULSE_SUPPORT_PHONE = '+7 (800) 200-10-97';
export const AGENT_WORK_SUPPORT_EMAIL = 'rabota_agentom@rgs.ru';
